import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Assuming you're using react-bootstrap

const DownloadModal = ({ show, onClose, files, isOpen }) => {

  const styles = {
    backgroundColor: "#F0F0F0",
    borderRadius: "5px",
    padding: "0px 40px",

  }

  const HeadStyle = {
    backgroundColor: "#F0F0F0",
  }


  const handleDownload = (url) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = ''; // Optional filename
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton style={HeadStyle}>
        <Modal.Title>Your Downloads</Modal.Title>
      </Modal.Header>
      <Modal.Body style={styles}>
        {files.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>Thumbnail</th>
                <th>File Name</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {files.map(file => (
                <tr key={file.id} style={{ alignItems: 'center' }}>
                  <td><img src={file.thumbnail || "../images/pieces/Grown_Mete_Mascot.png"} alt={file.name} style={{ width: '80px', height: 'auto' }} /></td>
                  <td>{file.name}</td>
                  <td >
                    
                      <Button className='PayBtn' onClick={() => handleDownload(file.asset)}>Download</Button>
                  
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No files available for download.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        
        <Button className='ClosePayBtn' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DownloadModal;